// extracted by mini-css-extract-plugin
export var breadcrumbs = "Breadcrumbs-module--breadcrumbs--e2272";
export var separator = "Breadcrumbs-module--separator--2cc3c";
export var white = "Breadcrumbs-module--white--43eec";